module.exports = __webpack_public_path__ + "img/focaccia-cheese.61a060f3.jpg";